/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Increase_Playback_SpeedInputs */



/**
* | output |
* | --- |
* | "Increase Playback Speed" |
*
* @param {Shortcut_Keys_Name_Increase_Playback_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_increase_playback_speed = /** @type {((inputs?: Shortcut_Keys_Name_Increase_Playback_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Increase_Playback_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Augmenter la vitesse de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiedergabegeschwindigkeit erhöhen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aumentare la velocità di riproduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличьте скорость воспроизведения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aumentar la velocidad de reproducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提高播放速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生速度を上げる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेबैक गति बढ़ाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aumentar a velocidade de reprodução")
	return /** @type {LocalizedString} */ ("Increase Playback Speed")
});